// extracted by mini-css-extract-plugin
export var page404Title = "RelatedServices-module--page404-title--3jrBy";
export var related_services_container = "RelatedServices-module--related_services_container--2-Kr4";
export var related_service = "RelatedServices-module--related_service--2MbK0";
export var related_services = "RelatedServices-module--related_services--2k9RX";
export var button_container = "RelatedServices-module--button_container--3Yakr";
export var seeAllButton = "RelatedServices-module--seeAllButton--3FLWP";